import React, { useState, useEffect } from 'react';
import TypingEffect from './TypingEffect';

const SequentialTyping = ({ lines, delay = 50 }) => {
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [visibleLines, setVisibleLines] = useState([]);

  useEffect(() => {
    if (currentLineIndex < lines.length) {
      // Calculate the time needed for the previous line to finish typing
      const previousLineLength = currentLineIndex > 0 ? lines[currentLineIndex - 1].length : 0;
      const typingTime = previousLineLength * delay;
      
      const timeout = setTimeout(() => {
        setVisibleLines(prev => [...prev, lines[currentLineIndex]]);
        setCurrentLineIndex(prev => prev + 1);
      }, typingTime + 500); // Add 500ms pause between lines

      return () => clearTimeout(timeout);
    }
  }, [currentLineIndex, delay, lines]);

  return (
    <div className="screen-content">
      {visibleLines.map((line, index) => (
        <TypingEffect key={index} text={line} delay={delay} />
      ))}
    </div>
  );
};

export default SequentialTyping; 